export const ForDrawingCard = ({sumToDrawing}) => {
    return (
        <div className="card" style={{width: "12rem", borderColor: "var(--app-gold)", borderWidth: "2px"}}>
            <div className="card-header d-flex justify-content-center" style={{borderColor: "var(--app-gold)", borderWidth: "2px"}}>
                <h4>Правно</h4>
            </div>
            <div className="d-flex justify-content-center">
                <h5 className="card-title p-3">{sumToDrawing?.toFixed(2)}</h5>
            </div>
        </div>
    )
}
